import { computed, Injectable, signal } from '@angular/core';
import { ONBOARDING_KEY, ONBOARDING_STEPS } from '../constants';
import { SecureStorageService } from './secure-storage.service';

@Injectable({ providedIn: 'root' })
export class SplashScreenService {
  currentStep = signal<number>(0);
  isFirstLaunch = signal<boolean>(false);

  isLastStep = computed(() => this.currentStep() === ONBOARDING_STEPS.length - 1);
  isFirstStep = computed(() => this.currentStep() === 0);

  constructor(
    private secureStorageService: SecureStorageService,
  ) {}

  async checkFirstLaunch(): Promise<void> {
    const isOnboardingComplete = !!(await this.secureStorageService.getSecureStorageData(ONBOARDING_KEY));
    this.isFirstLaunch.set(!isOnboardingComplete);
    this.currentStep.set(0);
  }

  async completeOnboarding(): Promise<void> {
    await this.secureStorageService.setSecureStorageData(ONBOARDING_KEY, 'true');
  }

  nextStep(): void {
    if (!this.isLastStep()) {
      this.currentStep.update((s) => s + 1);
    }
  }

  previousStep(): void {
    if (!this.isFirstStep()) {
      this.currentStep.update((s) => s - 1);
    }
  }
}
